// SideMenuModals.jsx
// Modals used by the side menu, pulled out for clarity.

import React from "react";
import { Modal, Select, Spin, Image } from "antd";
import { StudentProfile } from "../profile/StudentProfile";
import { StaffProfile } from "../profile/StaffProfile";
import ZoomPickerV2 from "../zoom-picker/ZoomPickerV2";
import BraineeLiveClassPicker from "../brainee-live-class/BraineeLiveClassPicker";

const { Option } = Select;

const STAFF_ROLES = ["Super Admin", "Admin", "Teacher", "Registrar"];

// ---------------------------------------------------------------------------
// School year modal
// ---------------------------------------------------------------------------

export function SchoolYearModal({
  open,
  updating,
  schoolYearList,
  currentSchoolYear,
  onSchoolYearChange,
  onOk,
  onCancel,
}) {
  return (
    <Modal
      title={
        <div>
          <Image src="../images/brainee_mascot.png" preview={false} height="30px" width="28px" />
          {" "}Change School Year
        </div>
      }
      centered
      destroyOnClose
      open={open}
      onOk={onOk}
      onCancel={onCancel}
      okText="Change"
      okButtonProps={{ shape: "round", type: "primary" }}
      cancelButtonProps={{ shape: "round" }}
    >
      <Spin spinning={updating} tip="Changing, please wait...">
        {schoolYearList.length > 0 && (
          <Select
            showArrow
            size="middle"
            style={{ width: "100%", marginTop: 5 }}
            allowClear
            placeholder="Select School Year"
            defaultValue={currentSchoolYear}
            onChange={onSchoolYearChange}
          >
            {schoolYearList.map(({ value, name }) => (
              <Option key={value} value={value}>
                {name}
              </Option>
            ))}
          </Select>
        )}
      </Spin>
    </Modal>
  );
}

// ---------------------------------------------------------------------------
// Profile modal
// ---------------------------------------------------------------------------

export function ProfileModal({
  open,
  userRole,
  userId,
  canChangeUsername,
  canChangePassword,
  onPictureUploaded,
  onCancel,
}) {
  return (
    <Modal
      className="profile-modal"
      title="My Profile"
      centered
      destroyOnClose
      open={open}
      onCancel={onCancel}
      okButtonProps={{ style: { display: "none" } }}
      cancelButtonProps={{ style: { display: "none" } }}
      width="75%"
      style={{ minWidth: 400 }}
    >
      {STAFF_ROLES.includes(userRole) ? (
        <StaffProfile
          staffID={userId}
          onCancelCallback={onCancel}
          onPictureUploaded={onPictureUploaded}
        />
      ) : (
        <StudentProfile
          studentID={userId}
          onCancelCallback={onCancel}
          canChangeUsername={canChangeUsername}
          canChangePassword={canChangePassword}
          onPictureUploaded={onPictureUploaded}
        />
      )}
    </Modal>
  );
}

// ---------------------------------------------------------------------------
// Zoom picker modal
// ---------------------------------------------------------------------------

export function ZoomPickerModal({ open, onClose }) {
  return (
    <Modal
      key="zoom-picker-modal"
      title={
        <div>
          <Image src="../images/brainee_mascot.png" preview={false} height="30px" width="28px" />
          {" "}Zoom Picker
        </div>
      }
      centered
      destroyOnClose
      open={open}
      onOk={onClose}
      onCancel={onClose}
      okText="Close"
      okButtonProps={{ className: "modal-dismiss-btn" }}
      cancelButtonProps={{ style: { display: "none" } }}
      width="30%"
      style={{ minWidth: 300 }}
    >
      <ZoomPickerV2 />
    </Modal>
  );
}

// ---------------------------------------------------------------------------
// Brainee live class picker modal
// ---------------------------------------------------------------------------

export function BraineeLiveClassPickerModal({ open, onClose }) {
  return (
    <Modal
      key="brainee-live-class-picker-modal"
      title={
        <div>
          <Image src="../images/brainee_mascot.png" preview={false} height="30px" width="28px" />
          {" "}Brainee Live Class Picker
        </div>
      }
      centered
      destroyOnClose
      open={open}
      onOk={onClose}
      onCancel={onClose}
      cancelText="Close"
      okButtonProps={{ style: { display: "none" } }}
      width={window.innerWidth < 768 ? "90%" : "45%"}
      style={{ minWidth: window.innerWidth < 768 ? "" : 450 }}
    >
      <BraineeLiveClassPicker />
    </Modal>
  );
}
